module.exports = __webpack_public_path__ + "static/media/toa-title-white.c5f25eb0.svg";